import React, { useContext } from 'react';
import styled from 'styled-components';
import { Header2 } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useEmployeePackages from '@ubeya/shared/hooks/account/useEmployeePackages';
import { AccordionSummaryContainer } from '@ubeya/shared-web/components/Accordion/Accordion';
import { RootContainer, RootWrapper } from '../styled';

const PackageItem = styled.div`
  display: flex;
  padding-left: 13px;
  margin-bottom: 5px;
`;

const PackageName = styled.div`
  font-weight: 500;
  margin-right: 5px;
`;

const EmployeeWorkingTimeDirective = ({ data: employeeData }) => {
  const { t } = useContext(ConfigContext);

  const { id: employeeId } = employeeData || {};
  const { data } = useEmployeePackages({ employeeId });

  return (
    <RootWrapper>
      <RootContainer>
        <AccordionSummaryContainer>
          <Header2> {t('workingTimeDirective')} </Header2>
        </AccordionSummaryContainer>
        {(data || []).map((currPackage, index) => (
          <PackageItem key={index}>
            <PackageName>{t('packageName')}:</PackageName>

            {currPackage?.name}
          </PackageItem>
        ))}
      </RootContainer>
    </RootWrapper>
  );
};

export default React.memo(EmployeeWorkingTimeDirective);
